export default __webpack_public_path__ + "static/media/Logo_HHSW.92891ef7.svg";